export const MESSAGES = {
    NO_DATA_GENERATED: 'No data has been generated!.',
    NO_RESULTS: 'No results!!!',
    DELETE_PROJECT: 'Are you sure you would like to  delete the project?',
    DELETE_TRANSLATION_PROJECT: 'Are you sure you would like to delete the translation project?',
    NOTE: 'Note: This action cannot be done',
    DELETE_PROJECT_TITLE: 'Delete Project?',
    DELETE_TRANSLATION_PROJECT_TITLE: 'Delete Translation Project?',
    SAVE_CHANGES_TITLE: 'Save changes?',
    SAVE_CHANGES_MSG: 'There are unsaved changes, click on save changes to save it or do you want to still proceed Further?',
    DELETE: 'DELETE',
    CANCEL: 'CANCEL',
    SAVE_CHANGES: 'SAVE CHANGES',
    PROCEED: 'PROCEED',
    DISCARD_CHANGES: 'DISCARD CHANGES',
    TRANSLATION_TITLE: 'Select Translation Language',
    TRANSLATION_CONTENT: 'Please select the language in which you would want to translate',
    APPLY: 'APPLY',

}